import React from "react";

const VRGlasses = () => {
  return (
    <>
      <style>
        {`
          @keyframes gradientMove {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0px) translateX(0px);
            }
            33% {
              transform: translateY(-30px) translateX(15px);
            }
            66% {
              transform: translateY(15px) translateX(-15px);
            }
          }

          @keyframes vrRotate {
            0% {
              transform: perspective(1000px) rotateY(0deg) rotateX(5deg);
            }
            50% {
              transform: perspective(1000px) rotateY(15deg) rotateX(-5deg);
            }
            100% {
              transform: perspective(1000px) rotateY(0deg) rotateX(5deg);
            }
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 0.6;
              transform: scale(1);
            }
            50% {
              opacity: 1;
              transform: scale(1.05);
            }
          }

          @keyframes scanLine {
            0% {
              top: 0%;
            }
            100% {
              top: 100%;
            }
          }

          @keyframes hologram {
            0%, 100% {
              opacity: 0.8;
              transform: translateZ(0px);
            }
            50% {
              opacity: 1;
              transform: translateZ(30px);
            }
          }

          .project-page {
            position: relative;
            background: linear-gradient(-45deg, #000000, #0a0a0a, #1a0a1a, #0a1a2a);
            background-size: 400% 400%;
            animation: gradientMove 15s ease infinite;
            min-height: 100vh;
            padding: 90px 20px;
            color: #fff;
            font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
            overflow: hidden;
          }

          .project-page::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: 
              radial-gradient(circle at 20% 30%, rgba(139, 92, 246, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(59, 130, 246, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 40% 80%, rgba(236, 72, 153, 0.1) 0%, transparent 50%);
            animation: float 20s ease-in-out infinite;
            pointer-events: none;
          }

          .project-page::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: 
              repeating-linear-gradient(
                0deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              ),
              repeating-linear-gradient(
                90deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              );
            pointer-events: none;
          }

          .project-container {
            max-width: 1200px;
            margin: auto;
            position: relative;
            z-index: 1;
          }

          .project-badge {
            display: inline-block;
            background: linear-gradient(135deg, #8b5cf6, #3b82f6);
            padding: 8px 24px;
            border-radius: 30px;
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 30px;
            text-transform: uppercase;
            letter-spacing: 1.5px;
          }

          .project-title {
            font-size: 52px;
            font-weight: 700;
            margin-bottom: 40px;
            letter-spacing: 1px;
            background: linear-gradient(135deg, #8b5cf6, #3b82f6, #ec4899, #8b5cf6);
            background-size: 300% 300%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: gradientMove 8s ease infinite;
          }

          .hero-section {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 60px;
            align-items: center;
            margin-bottom: 100px;
          }

          .hero-content {
            padding-right: 20px;
          }

          .hero-text {
            font-size: 18px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            margin-bottom: 20px;
          }

          .vr-animation-container {
            position: relative;
            height: 500px;
            display: flex;
            align-items: center;
            justify-content: center;
            perspective: 1000px;
          }

          .vr-headset {
            position: relative;
            width: 320px;
            height: 180px;
            background: linear-gradient(145deg, #1a1a2e, #16213e);
            border-radius: 90px;
            box-shadow: 
              0 30px 80px rgba(0, 0, 0, 0.9),
              inset 0 -20px 40px rgba(0, 0, 0, 0.5),
              0 0 60px rgba(139, 92, 246, 0.4);
            animation: vrRotate 8s ease-in-out infinite;
            border: 3px solid rgba(139, 92, 246, 0.3);
          }

          .vr-lenses {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            gap: 40px;
          }

          .lens {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background: radial-gradient(circle at 30% 30%, #3b82f6, #1e40af, #000);
            box-shadow: 
              inset 0 0 30px rgba(59, 130, 246, 0.6),
              0 0 40px rgba(139, 92, 246, 0.5);
            position: relative;
            overflow: hidden;
            animation: pulse 3s ease-in-out infinite;
          }

          .lens::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: rgba(59, 130, 246, 0.8);
            animation: scanLine 2s linear infinite;
          }

          .lens-left {
            animation-delay: 0s;
          }

          .lens-right {
            animation-delay: 0.5s;
          }

          .vr-strap {
            position: absolute;
            top: 50%;
            width: 120%;
            height: 30px;
            background: linear-gradient(90deg, transparent, #1a1a2e 20%, #1a1a2e 80%, transparent);
            transform: translateY(-50%);
            left: -10%;
            border-radius: 15px;
            opacity: 0.6;
          }

          .hologram-effect {
            position: absolute;
            width: 200px;
            height: 200px;
            border: 2px solid rgba(139, 92, 246, 0.4);
            border-radius: 20px;
            animation: hologram 4s ease-in-out infinite;
          }

          .hologram-1 {
            top: -50px;
            right: -80px;
            animation-delay: 0s;
          }

          .hologram-2 {
            bottom: -50px;
            left: -80px;
            animation-delay: 1s;
          }

          .glow-ring {
            position: absolute;
            border-radius: 50%;
            border: 2px solid rgba(139, 92, 246, 0.2);
            animation: pulse 4s ease-in-out infinite;
          }

          .ring-1 {
            width: 400px;
            height: 400px;
          }

          .ring-2 {
            width: 500px;
            height: 500px;
            border-color: rgba(59, 130, 246, 0.15);
            animation-delay: 1s;
          }

          .ring-3 {
            width: 600px;
            height: 600px;
            border-color: rgba(236, 72, 153, 0.1);
            animation-delay: 2s;
          }

          .description-section {
            background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
            padding: 60px;
            border-radius: 20px;
            margin-bottom: 40px;
            box-shadow: 0 25px 50px rgba(0, 0, 0, 0.7);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .description-section:hover {
            transform: translateY(-8px);
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.9);
          }

          .section-title {
            font-size: 32px;
            font-weight: 600;
            margin-bottom: 25px;
            background: linear-gradient(135deg, #8b5cf6, #3b82f6);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .section-text {
            font-size: 17px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            margin-bottom: 20px;
          }

          .highlight-box {
            background: linear-gradient(135deg, rgba(139, 92, 246, 0.1), rgba(59, 130, 246, 0.1));
            border-left: 4px solid #8b5cf6;
            padding: 25px;
            border-radius: 10px;
            margin: 30px 0;
          }

          .highlight-text {
            font-size: 17px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            font-style: italic;
          }

          @media (max-width: 968px) {
            .hero-section {
              grid-template-columns: 1fr;
              gap: 40px;
            }

            .project-title {
              font-size: 38px;
            }

            .vr-animation-container {
              height: 400px;
            }

            .description-section {
              padding: 40px;
            }

            .vr-headset {
              width: 260px;
              height: 150px;
            }

            .lens {
              width: 60px;
              height: 60px;
            }
          }
        `}
      </style>

      <section className="project-page">
        <div className="project-container">
          <div className="project-badge">Upcoming Project</div>
          <h1 className="project-title">VR Glasses</h1>

          {/* Hero Section */}
          <div className="hero-section">
            <div className="hero-content">
              <p className="hero-text">
                Zyntro Software Solutions is thrilled to unveil our ambitious VR Glasses project, a next-generation virtual reality platform that promises to transform how users experience digital content, interactive environments, and immersive applications. This cutting-edge technology represents our commitment to pushing the boundaries of human-computer interaction, creating experiences that blur the lines between physical and digital realities.
              </p>
              <p className="hero-text">
                Our VR Glasses combine state-of-the-art optics, advanced motion tracking, and powerful processing capabilities to deliver an unparalleled immersive experience. Whether for gaming, professional training, virtual collaboration, educational simulations, or entertainment, our solution offers crystal-clear visuals, intuitive controls, and seamless integration with existing digital ecosystems, making virtual reality accessible and practical for everyday use.
              </p>
            </div>

            <div className="vr-animation-container">
              <div className="glow-ring ring-1"></div>
              <div className="glow-ring ring-2"></div>
              <div className="glow-ring ring-3"></div>
              <div className="vr-headset">
                <div className="vr-strap"></div>
                <div className="vr-lenses">
                  <div className="lens lens-left"></div>
                  <div className="lens lens-right"></div>
                </div>
                <div className="hologram-effect hologram-1"></div>
                <div className="hologram-effect hologram-2"></div>
              </div>
            </div>
          </div>

          {/* Description Section 1 */}
          <div className="description-section">
            <h2 className="section-title">Immersive Technology & Design Innovation</h2>
            <p className="section-text">
              At the core of our VR Glasses project lies groundbreaking display technology that delivers stunning visual fidelity and immersive depth perception. Our headset features dual high-resolution OLED displays with a combined resolution exceeding 4K per eye, ensuring that every virtual environment appears remarkably lifelike and detailed. The advanced optical system incorporates custom-designed Fresnel lenses that provide an expansive field of view exceeding 120 degrees, creating a truly encompassing visual experience that draws users completely into virtual worlds.
            </p>
            <p className="section-text">
              The refresh rate of 120Hz combined with low-persistence displays virtually eliminates motion blur and reduces latency to imperceptible levels, ensuring smooth, comfortable experiences even during fast-paced action sequences or rapid head movements. Our proprietary visual processing pipeline includes real-time foveated rendering, which concentrates rendering power on the user's focal point while intelligently reducing detail in peripheral vision, maximizing performance without compromising perceived visual quality. This technology enables our VR Glasses to run demanding applications while maintaining exceptional battery life and thermal efficiency.
            </p>
            <div className="highlight-box">
              <p className="highlight-text">
                "Our vision is to create VR technology that feels as natural as looking through a window into another world. Every design decision, from the weight distribution to the lens configuration, has been made with user comfort and immersion as the primary consideration."
              </p>
            </div>
            <p className="section-text">
              Comfort and ergonomics have been paramount in our design process. The VR Glasses feature a lightweight construction utilizing aerospace-grade materials that distribute weight evenly across the head, preventing fatigue during extended use sessions. The adjustable head strap system accommodates various head sizes and shapes, while the customizable interpupillary distance (IPD) adjustment ensures optimal visual clarity for all users. The device includes integrated spatial audio with precision-tuned speakers positioned for accurate 3D sound positioning, eliminating the need for separate headphones while delivering immersive audio that complements the visual experience. Advanced ventilation channels prevent lens fogging and maintain comfortable temperatures during intensive use.
            </p>
          </div>

          {/* Description Section 2 */}
          <div className="description-section">
            <h2 className="section-title">Applications & Ecosystem Integration</h2>
            <p className="section-text">
              The true power of our VR Glasses extends far beyond hardware specifications into a comprehensive ecosystem of applications and use cases that span industries and user needs. For gaming enthusiasts, our platform supports an extensive library of immersive titles, from action-packed adventures to contemplative exploration games, all optimized to take full advantage of our headset's capabilities. The intuitive controller system provides precise input with haptic feedback that enhances immersion, while hand-tracking technology allows for natural gesture-based interactions in supported applications.
            </p>
            <p className="section-text">
              In professional environments, our VR Glasses are revolutionizing training and collaboration. Medical professionals can practice complex procedures in risk-free virtual environments with anatomically accurate simulations. Architects and designers can walk through their creations at full scale before construction begins, making real-time modifications and sharing immersive presentations with clients worldwide. Manufacturing facilities use our VR solution for equipment training, reducing costly downtime and improving worker safety by allowing practice in virtual replicas of actual facilities. Remote teams collaborate in shared virtual workspaces that feel more present and productive than traditional video conferencing.
            </p>
            <p className="section-text">
              Educational institutions are adopting our VR Glasses to create engaging learning experiences that were previously impossible. Students can explore ancient civilizations, dive into molecular structures, travel through space, or practice language skills in simulated real-world environments. The technology makes abstract concepts tangible and allows learners to engage with subjects in ways that significantly improve retention and understanding. Our educational platform includes curriculum-aligned content developed in partnership with leading educators and subject matter experts.
            </p>
            <p className="section-text">
              The device seamlessly integrates with existing technology ecosystems, supporting both standalone operation and tethered connectivity to high-performance computers for demanding applications. Our open development platform enables creators to build custom applications using industry-standard tools and frameworks. Cloud connectivity allows users to access their content libraries from anywhere, while social features enable shared experiences with friends and family regardless of physical location. As Zyntro Software Solutions continues to develop this platform, we remain committed to making virtual reality an integral, accessible part of daily life, opening new possibilities for entertainment, education, professional development, and human connection across digital frontiers.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default VRGlasses;